import { apiClient } from './client';
import type { CreditsTestEmail, ProjectCredits } from './types';

const base = (slug: string) => `/projects/${encodeURIComponent(slug)}/credits`;

/** Every provider account of the project, as last checked. */
export async function getCredits(slug: string): Promise<ProjectCredits> {
  return (await apiClient.get<ProjectCredits>(base(slug))).data;
}

/** Check every account now (no provider credit spent); the alert emails apply. */
export async function refreshCredits(slug: string): Promise<ProjectCredits> {
  return (await apiClient.post<ProjectCredits>(`${base(slug)}/refresh`)).data;
}

/** Send the last checked state to the alert recipients, marked as a test. */
export async function sendCreditsTestEmail(slug: string): Promise<CreditsTestEmail> {
  return (await apiClient.post<CreditsTestEmail>(`${base(slug)}/test-email`)).data;
}
